import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import Button from '../../../components/Button';
import InputBox from '../../../components/InputBox';
import { toast } from 'react-toastify';
import './BulkJobUploadModal.scss';
import fetchRecruiterProfile from '../../../services/fetchRecruiterProfile';
const BulkJobUploadModal = ({ show, onClose, onSubmit, adminId, fromSI }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    recruiterId: '',
    file: null,
    freeText: "",
    isCrawled: fromSI ? 1 : 0
  });

  console.log("FROM SI --", fromSI);
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      isCrawled: fromSI ? 1 : 0
    }));
  }, [fromSI]);

  const handleFormChange = (event) => {
    const { name, value, files } = event.target;
    console.log(name, value);
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleCheckboxChange = (event) => {
    // console.log(event, event.target);
    // debugger
    event.persist();
    console.log(event, event.target);
    setFormData(prev => ({
      ...prev,
      [event.target.name]: event.target.checked ? 1 : 0
    }));
  }

  const handleSubmit = async () => {
    try {

      if (isLoading) return;

      setIsLoading(true);
      if (!formData.recruiterId || (!formData.file && !formData.freeText)) {
        toast.error('Please fill all required fields');
        return;
      }
      if (formData.recruiterId) {
        //check recruiterId is valid email

        let recruiterProfile = null;
        // Check if recruiterId is an email or a number
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.recruiterId);
        const idParam = isEmail ? { email: formData.recruiterId } : { id: formData.recruiterId };
        recruiterProfile = await fetchRecruiterProfile(adminId, idParam);
        if (!recruiterProfile || !recruiterProfile.data) {
          toast.error('Recruiter not found');
          return;
        }
        if (recruiterProfile.data.status != 1) {
          toast.error('Recruiter is not active');
          return;
        }
        formData.recruiterId = recruiterProfile.data.id;
      }
      const data = new FormData();
      data.append('recruiterId', formData.recruiterId);
      if (formData.file)
        data.append('file', formData.file);
      data.append('freeText', formData.freeText);
      data.append('isCrawled', formData.isCrawled);

      console.log(data);
      await onSubmit(data);
      setFormData({ recruiterId: '', file: null });
    } catch (error) {
      console.error('Error in form submission:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      className='bulk-upload-modal'
      open={show}
      onClose={onClose}
    >
      <Modal.Header>Add New Bulk Job</Modal.Header>
      <Modal.Content>
        <div className="bulk-upload-form">
          <div className="form-group">
            <label className='modal-label'>Recruiter ID *</label>
            <InputBox
              name="recruiterId"
              value={formData.recruiterId}
              onChange={handleFormChange}
              placeholder="Enter Recruiter ID or Email"
            />
          </div>

          <div className="form-group">
            <label>Upload File *</label>
            <input
              type="file"
              name="file"
              accept=".csv,.txt,.xlsx,.doc,.docx,.pdf,.png,.jpg,.jpeg"
              onChange={handleFormChange}
              className="file-input"
            />

            <div className="file-help-text">
              Supported formats:.csv,.txt,.xlsx,.doc,.docx,.pdf,.png,.jpg,.jpeg
              <br />
            </div>
          </div>
          <div>OR</div>
          <br />
          <div className='form-group'>
            <label className='modal-label'> Enter Job Details* </label>
            <textarea style={{ width: "100%", padding: "7px 10px", border: "1px solid #ccc" }} className='input-box' placeholder='Enter Job Details' value={formData.freeText} name='freeText' rows='5' onChange={handleFormChange}>
            </textarea>
          </div>

          <br />
          <b style={{ color: "red" }}>Note - Please refrain from sharing any personal information such as recruiters' email addresses or phone numbers</b>

          <br />
          <br />

          <div className="form-group">
            <label className='block'>
              <input
                type='checkbox'
                name='isCrawled'
                checked={!!formData.isCrawled}
                onChange={handleCheckboxChange}
              /> Job from Job Universe
            </label>
          </div>


        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          skin="light"
          text="Cancel"
          clickButton={onClose}
        />
        <Button
          skin="dark"
          text="Submit"
          loading={isLoading}
          clickButton={handleSubmit}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default BulkJobUploadModal;